/**
 * Simple check to validate that a browser supports the Performance API.
 * @TODO Optimize this check in the future since it actually only needs to run once.
 */
export default (): boolean =>
  Object.prototype.hasOwnProperty.call(window, 'performance') &&
  typeof window.performance.mark === 'function' &&
  typeof window.performance.measure === 'function' &&
  typeof window.performance.getEntriesByName === 'function';
